export const toKeys = <T>(obj: Record<string, T>) => {
  return Object.keys(obj).filter((key) => obj.hasOwnProperty(key))
}

export const toArray = <T>(obj: Record<string, T>) => {
  return toKeys(obj).map((key) => obj[key])
}

export const objectToQueryParam = <T extends Object>(obj: T): string => {
  const filterString = Object.entries(obj)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${key}=${v}`).join('&')
      }
      return `${key}=${value}`
    })
    .filter(Boolean)
    .join('&')
  return filterString ? `?${filterString}` : ''
}
